import * as React from 'react';

export const BottomTabBarHeightContext = React.createContext<
  number | undefined
>(undefined);
